import createAuthAxios from 'common/lib/createAuthAxios';
import { SuggestionItemType } from 'common/components/CopyMagic/CopyMagic.types';

type FetchSuggestionsRequest = {
  contextToken: string;
  pagePath: string;
};

type SuggestionMetaType = {
  category: string;
  initialPrompt: string;
  aiConsentRequired: boolean;
  siteId: string | null;
};

export type FetchSuggestionsResponse = Readonly<{
  data: SuggestionItemType[];
  meta: SuggestionMetaType;
}>;

const fetchSuggestions = async ({ contextToken, pagePath }: FetchSuggestionsRequest) => {
  const authAxios = createAuthAxios();

  const url = `/api/admin/copy_magic/suggestions`;
  const method = 'GET';
  const params = {
    context_token: contextToken,
    page_path: pagePath,
  };
  const { data } = await authAxios.request<FetchSuggestionsResponse>({ url, method, params });

  return data;
};

export default fetchSuggestions;
